
































import { Vue, Component, PropSync, Watch, Ref } from 'vue-property-decorator'
import CompleteUserProfile from './CompleteUserProfile'
import CompleteUserProfileDetails from '@/modules/member/components/MemberOnboardActionDialog/CompleteUserProfileDetails/CompleteUserProfileDetails.vue'
import { getModule } from 'vuex-module-decorators'
import userStore from '@/modules/auth/auth.store'
import sharedStore from '@/modules/shared/shared.store'

@Component({
  components: {
    CompleteUserProfileDetails,
    CompleteUserProfile
  }
})
export default class MemberOnboardActionDialog extends Vue {
  userModule = getModule(userStore, this.$store)
  sharedModule = getModule(sharedStore, this.$store)

  @PropSync('visible', { default: false })
  isVisible!: boolean

  step: number = 1
  steps: number[] = Array.from(new Array(2), (_, index) => index + 1)

  @Ref('completeUserProfile')
  readonly completeUserProfile!: CompleteUserProfile

  @Ref('completeUserProfileDetails')
  readonly completeUserProfileDetails!: CompleteUserProfileDetails

  @Watch('isVisible')
  onDialogVisiblityChanged(visible: boolean) {
    if (visible) {
      this.step = 1
    } else {
      setTimeout(() => {
        this.step = 1
      }, 200)

      if (this.completeUserProfile) {
        this.completeUserProfile.reset()
      }
      if (this.completeUserProfileDetails) {
        this.completeUserProfileDetails.reset()
      }
    }
  }

  finish() {
    this.isVisible = false
    this.$toast.success(this.$t('MemberOnboardAction.ThankYou'))
    this.userModule.fetchMember().then()
    this.sharedModule.updateSuggestedRegion().then()
  }
}
